export default {
    reviewOrder: {
        reviewOrder: "Réviser la commande"
    }
}